<template>
  <div id="coupon-wrapper">
    <Coupon
      v-for="(value, key) in coupon"
      :key="key"
      :coupon="value"
      :is-list-view="true"
      :isShowButton="!isComponent"
    />
    <div v-if="!isComponent" class="btn-secondary" @click="$emit('next')">返回上一页</div>
    <div v-else class="btn-primary" @click="$emit('complete')">下一步</div>
  </div>
</template>

<script>
import Coupon from "@/components/public/Coupon.vue"
export default {
  name: "CouponWrapper",
  props: ["coupon", "isComponent"],
  components: {
    Coupon,
  },
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
